import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { Router } from '@angular/router';
 import { ApplicationError } from './appplication-error.model';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

	private message = null;

    constructor(private injector: Injector) {
    }
 
    handleError(error) {
 

        if (error instanceof ApplicationError) {

            let router = this.injector.get(Router);
        //     console.log('URL: ' + router.url);
        //     console.error('An error occurred:', error.message);
           
        //    alert(error);
    
            router.navigate(['/app/customerror'])          
        }
       
	}

	setMessage(message: string) {
		this.message = message;

	}

	getMessage() {
		return this.message;
	}
}
